/**
 * Zerra Search — risultati live in-page (niente dropdown a tenda).
 * Usa /search/suggest.json → resources.results.*
 */
(function () {
  function bindZerraSearchLive(root) {
  if (!root || root.dataset.zerraSearchBound === 'true') return;
  root.dataset.zerraSearchBound = 'true';

  const input =
    root.querySelector('[data-zerra-search-input]') ||
    root.querySelector('#Search-In-Template') ||
    root.querySelector('input[type="search"]');
  const live = root.querySelector('[data-zerra-search-live]');
  const stage = root.querySelector('[data-zerra-search-stage]');
  const form = root.querySelector('form');
  if (!input || !live) return;

  let timer = null;
  let abort = null;

  function formatMoney(price) {
    if (price == null || price === '') return '';
    const value = Number(price);
    if (Number.isNaN(value)) return '';
    // suggest.json restituisce prezzi in unità moneta (es. 350.00), non centesimi
    return value.toLocaleString('it-IT', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
    });
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function safeUrl(url) {
    const raw = String(url || '').trim();
    if (!raw) return '#';
    if (/^(javascript|data|vbscript):/i.test(raw)) return '#';
    if (/^(https?:|mailto:|tel:)/i.test(raw)) return raw;
    if (raw.startsWith('/') || raw.startsWith('#') || raw.startsWith('./') || raw.startsWith('../')) return raw;
    return '#';
  }

  function safeImgUrl(url) {
    const raw = String(url || '').trim();
    if (!raw) return '';
    if (/^(javascript|vbscript):/i.test(raw)) return '';
    if (/^data:/i.test(raw) && !/^data:image\//i.test(raw)) return '';
    if (/^(https?:)/i.test(raw)) return raw;
    if (raw.startsWith('//') || raw.startsWith('/')) return raw;
    return '';
  }

  function setBusy(busy) {
    root.classList.toggle('is-searching', busy);
    live.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function clearLive() {
    live.innerHTML = '';
    live.hidden = true;
    root.classList.remove('has-live-results');
    if (stage) stage.hidden = false;
  }

  function renderEmpty(term) {
    live.hidden = false;
    root.classList.add('has-live-results');
    if (stage) stage.hidden = true;
    live.innerHTML = `
      <div class="zerra-search-live__empty">
        <p class="zerra-search-live__empty-title">Nessun match</p>
        <p class="zerra-search-live__empty-text">Nessun prodotto per “${escapeHtml(term)}”. Prova le prime lettere del titolo o premi Invio.</p>
      </div>
    `;
  }

  const isHeader = Boolean(root.closest('[data-zerra-search-panel]') || root.hasAttribute('data-zerra-search-panel'));

  function sizedCdnUrl(url, width) {
    const raw = safeImgUrl(url);
    if (!raw) return '';
    try {
      const parsed = new URL(raw, window.location.origin);
      parsed.searchParams.set('width', String(width));
      parsed.searchParams.delete('height');
      parsed.searchParams.delete('crop');
      return parsed.toString();
    } catch (err) {
      return raw;
    }
  }

  function productImageUrl(product) {
    if (typeof product.image === 'string' && product.image) return product.image;
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image && product.featured_image.url) return product.featured_image.url;
    if (product.featured_image && product.featured_image.src) return product.featured_image.src;
    return '';
  }

  function productCard(product, index) {
    const img = sizedCdnUrl(productImageUrl(product), isHeader ? 900 : 720);
    const title = product.title || '';
    const url = safeUrl(product.url || '#');
    const price = formatMoney(product.price_min != null ? product.price_min : product.price);
    const vendor = product.vendor || product.type || '';
    const delay = Math.min(index * 40, 280);
    const imgSize = isHeader ? 900 : 720;

    return `
      <a class="zerra-search-live__card" href="${escapeHtml(url)}" style="--i:${index}; --d:${delay}ms">
        <div class="zerra-search-live__media">
          ${
            img
              ? `<img src="${escapeHtml(img)}" alt="" loading="lazy" width="${imgSize}" height="${imgSize}">`
              : `<span class="zerra-search-live__ph">Zerra</span>`
          }
        </div>
        <div class="zerra-search-live__body">
          ${vendor ? `<p class="zerra-search-live__meta">${escapeHtml(vendor)}</p>` : ''}
          <h3 class="zerra-search-live__title">${escapeHtml(title)}</h3>
          ${price ? `<p class="zerra-search-live__price">${escapeHtml(price)}</p>` : ''}
          ${isHeader ? '' : '<span class="zerra-search-live__cta">Apri <span aria-hidden="true">→</span></span>'}
        </div>
      </a>
    `;
  }

  function normalizeProducts(data) {
    if (Array.isArray(data && data.products)) return data.products;
    const results =
      (data && data.resources && data.resources.results) ||
      (data && data.resources) ||
      {};
    if (Array.isArray(results.products)) return results.products;
    if (Array.isArray(data && data.results)) {
      return data.results.filter((item) => !item.object_type || item.object_type === 'product');
    }
    return [];
  }

  function renderResults(data, term) {
    const products = normalizeProducts(data).slice(0, isHeader ? 16 : 10);

    if (!products.length) {
      renderEmpty(term);
      return;
    }

    live.hidden = false;
    root.classList.add('has-live-results');
    if (stage) stage.hidden = true;

    let html = '';
    if (!isHeader) {
      html += `<div class="zerra-search-live__head">
        <p class="zerra-search-live__kicker">Anteprima risultati</p>
        <p class="zerra-search-live__term">“${escapeHtml(term)}”</p>
      </div>`;
    }

    html += `<div class="zerra-search-live__block">
      ${isHeader ? '' : '<p class="zerra-search-live__label">Prodotti</p>'}
      <div class="zerra-search-live__grid">
        ${products.map((p, i) => productCard(p, i)).join('')}
      </div>
    </div>
    <div class="zerra-search-live__foot">
      <button type="button" class="zerra-search-live__all" data-zerra-search-submit>
        ${isHeader ? 'Vedi tutti i prodotti' : 'Vedi tutti i risultati'}
      </button>
    </div>`;

    live.innerHTML = html;

    const allBtn = live.querySelector('[data-zerra-search-submit]');
    if (allBtn && form) {
      allBtn.addEventListener('click', () => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
  }

  function parsePayload(text) {
    const trimmed = String(text || '').trim();
    const start = trimmed.indexOf('{');
    const end = trimmed.lastIndexOf('}');
    if (start === -1 || end < start) throw new Error('invalid json');
    return JSON.parse(trimmed.slice(start, end + 1));
  }

  function buildSuggestUrl(term) {
    const rootPath =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const base =
      (window.routes && window.routes.predictive_search_url) ||
      `${rootPath}search/suggest`;

    const params = new URLSearchParams();
    params.set('q', term);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', '10');
    params.set('resources[limit_scope]', 'each');
    params.set('resources[options][unavailable_products]', 'last');
    params.set(
      'resources[options][fields]',
      'title,product_type,variants.title,vendor,variants.sku,tag'
    );

    const endpoint = base.endsWith('.json') ? base : `${base}.json`;
    return `${endpoint}?${params.toString()}`;
  }

  function buildUrl(term) {
    if (!isHeader) return buildSuggestUrl(term);

    const rootPath =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const params = new URLSearchParams();
    params.set('q', term);
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    params.set('view', 'zerra-ajax');
    return `${rootPath}search?${params.toString()}`;
  }

  function fetchLive(term) {
    if (abort) abort.abort();
    abort = new AbortController();
    setBusy(true);

    const load = (url) =>
      fetch(url, {
        signal: abort.signal,
        headers: { Accept: 'application/json' },
      }).then((r) => {
        if (!r.ok) throw new Error(String(r.status));
        return r.text().then(parsePayload);
      });

    load(buildUrl(term))
      .catch((err) => {
        if (err && err.name === 'AbortError') throw err;
        if (!isHeader) throw err;
        return load(buildSuggestUrl(term));
      })
      .then((data) => {
        renderResults(data, term);
      })
      .catch((err) => {
        if (err && err.name === 'AbortError') return;
        clearLive();
      })
      .finally(() => setBusy(false));
  }

  function onInput() {
    const term = input.value.trim();
    clearTimeout(timer);

    // 1 carattere = iniziali (h → Hisense); Shopify fa prefix match
    if (term.length < 1) {
      clearLive();
      return;
    }

    timer = setTimeout(() => fetchLive(term), 180);
  }

  input.addEventListener('input', onInput);
  input.addEventListener('search', onInput);

  if (form) {
    form.addEventListener('reset', () => {
      setTimeout(clearLive, 0);
    });
  }
  }

  function initAllZerraSearchLive() {
    document.querySelectorAll('[data-zerra-search]').forEach(bindZerraSearchLive);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllZerraSearchLive);
  } else {
    initAllZerraSearchLive();
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-zerra-search]').forEach((el) => delete el.dataset.zerraSearchBound);
    initAllZerraSearchLive();
  });
})();
